export enum EditQuestionnaireFormTypes {
    Title = 'title',
    Client = 'client',
    Vendor = 'vendor',
    Assessment = 'assessment',
    Template =  'template',
    Product = 'product',
    Implementation = 'implementation',
}